export const FETCH_ADMIN_WORKING_HOURS_REQUEST = "FETCH_ADMIN_WORKING_HOURS_REQUEST";
export const UPDATE_ADMIN_WORKING_HOURS_REQUEST = "UPDATE_ADMIN_WORKING_HOURS_REQUEST";
